(function () {
    'use strict';

    angular.module("imApp").factory("operationFactoryService", ['$ihttp', function ($ihttp) {
        let service = {
            getOperationFactory: function (parms) {
                return $ihttp.post({
                    method: 2038,
                    parameters: parms || {}
                });
            },
            listSelectEquipments: function (parms) {
                return $ihttp.post({
                    method: 2039,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2044,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
